export const SET_HRESS1E_INDEX_DISP = 'SET_HRESS1E_INDEX_DISP'
export const GET_HRESS1E_INDEX_DISP = 'GET_HRESS1E_INDEX_DISP'
export const SET_HRESS1E_DETAIL_DISP = 'SET_HRESS1E_DETAIL_DISP'
export const GET_HRESS1E_DETAIL_DISP = 'GET_HRESS1E_DETAIL_DISP'
export const TOGGLE_HRESS1E_PAGE = 'TOGGLE_HRESS1E_PAGE'
export const SET_HRESS1E_COLUMNS = 'SET_HRESS1E_COLUMNS'
export const GET_HRESS1E_COLUMNS = 'GET_HRESS1E_COLUMNS'
export const SET_HRESS1E_LABELS = 'SET_HRESS1E_LABELS'
export const GET_HRESS1E_LABELS = 'GET_HRESS1E_LABELS'
export const RECEIVED_HRESS1E_COLUMNS_LABELS = 'RECEIVED_HRESS1E_COLUMNS_LABELS'
export const SET_HRESS1E_INDEX = 'SET_HRESS1E_INDEX'
export const GET_HRESS1E_INDEX = 'GET_HRESS1E_INDEX'
export const SET_HRESS1E_INDEX_SELECTED = 'SET_HRESS1E_INDEX_SELECTED'
export const GET_HRESS1E_INDEX_SELECTED = 'GET_HRESS1E_INDEX_SELECTED'
export const RECEIVED_HRESS1E_INDEX = 'RECEIVED_HRESS1E_INDEX'
export const SET_HRESS1E_DETAIL = 'SET_HRESS1E_DETAIL'
export const POST_HRESS1E_DETAIL2_SAVE = 'POST_HRESS1E_DETAIL2_SAVE'
export const GET_HRESS1E_DETAIL = 'GET_HRESS1E_DETAIL'
export const RECEIVED_HRESS1E_DETAIL = 'RECEIVED_HRESS1E_DETAIL'
export const GET_HRESS1E_DROPDOWNS = 'GET_HRESS1E_DROPDOWNS'
export const SET_HRESS1E_DROPDOWNS = 'SET_HRESS1E_DROPDOWNS'
export const RECEIVED_HRESS1E_DROPDOWNS = 'RECEIVED_HRESS1E_DROPDOWNS'



// WEBPACK FOOTER //
// ./src/store/modules/hress1e/mutation-types.js